import {
  Box,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import { useState } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface Threat {
  Campaign: string;
  Date: string;
}

export interface Report {
  name: string;
}

interface CyberIntelligenceProps {
  threat_feeds: Threat[],
  reports: Report[],
  theme: any
}

const CyberIntelligence = ({threat_feeds, reports, theme}: CyberIntelligenceProps) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent<Element, Event>, newValue: number) => {
    setTabValue(newValue);
  };

  const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            {children}
          </Box>
        )}
      </div>
    );
  };

  const a11yProps = (index: number, size, color) => {
    return {
      id: `simple-tab-${index}`, 
      "aria-controls": `simple-tabpanel-${index}`,
      sx: {
        color: color.textDisabledColor,
        padding: 1,
        fontWeight: '400',
        fontSize: size,
        "&.Mui-selected": {
          fontWeight: '800',
          color: color.textColor,
        },
      },
    };
  };

  return (
    <Box>
      <Box className="mb-4">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
        >
          <Tab label={`Campaigns`} {...a11yProps(0, theme.font.medium, theme.colors)} />
          <Tab label={`Reports`} {...a11yProps(1, theme.font.medium, theme.colors)} />
        </Tabs>
      </Box>

      {/* Tab content #1 */}
      <TabPanel value={tabValue} index={0}>
        <Table>
          <TableHead>
            <TableRow className="ms-2">
              <TableCell className="ps-3" sx={{color: theme.colors.textColor, fontSize: theme.font.small}}>
                <strong style={{lineHeight: '1.43'}}>Campaigns</strong>
              </TableCell>
              <TableCell className="ps-3" sx={{color: theme.colors.textColor, fontSize: theme.font.small}}>
                <strong style={{lineHeight: '1.43'}}>Date</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {threat_feeds.map((item, index) => (
              <TableRow key={index}>
                <TableCell
                  className="p-3"
                  sx={{
                    color: theme.colors.textColor,
                    fontSize: theme.font.small,
                  }}
                >
                  {item.Campaign}
                </TableCell>
                <TableCell
                  className="p-3"
                  sx={{
                    color: theme.colors.textColor,
                    fontSize: theme.font.small,
                  }}
                >
                  {item.Date}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TabPanel>

      {/* Tab content #2 */}
      <TabPanel value={tabValue} index={1}>
        <Table sx={{ minHeight: "334px" }}>
          <TableBody>
            {reports.map((item, index) => (
              <TableRow key={index}>
                <TableCell
                  sx={{ 
                    color: theme.colors.textColor, 
                    fontSize: theme.font.small
                  }}
                >
                  {item.name}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TabPanel>
    </Box>
  );
};

export default CyberIntelligence;
